/** @format */

import { ref, watch, computed } from '@vue/composition-api'

import store from '@/store'

export default function useInvoicesList(proxy) {
  const isLoading = ref(false)
  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'id',
      label: '序号',
      thStyle: {
        width: '100px',
      },
    },
    {
      key: 'cate_id',
      label: '类型',
      sortable: false,
      thStyle: {
        width: '130px',
      },
    },
    {
      key: 'member.real_name',
      label: '会员名称',
      sortable: false,
      thStyle: {
        width: '120px',
      },
    },
    {
      key: 'order.number',
      label: '保单号',
      sortable: false,
      thStyle: {
        width: '120px',
      },
    },
    {
      key: 'before_money',
      label: '变更前佣金',
      sortable: false,
      thStyle: {
        width: '150px',
      },
    },
    {
      key: 'after_money',
      label: '变更后佣金',
      sortable: false,
      thStyle: {
        width: '150px',
      },
    },
    {
      key: 'change_moeny',
      label: '变更佣金',
      sortable: false,
      thStyle: {
        width: '150px',
      },
    },
    {
      key: 'type',
      label: '类型',
      sortable: false,
      thStyle: {
        width: '100px',
      },
    },
    {
      key: 'desc',
      label: '描述',
      sortable: false,
      thStyle: {
        width: '100px',
      },
    },
    {
      key: 'status',
      label: '状态',
      sortable: false,
      thStyle: {
        width: '80px',
      },
    },
    {
      key: 'created_at',
      label: '创建时间',
      sortable: false,
      thStyle: {
        width: '120px',
      },
    },
  ]
  const perPage = ref(10)
  const pageSize = ref(100)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const user_id = ref('')
  const order_id = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value ? refInvoiceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch([currentPage, perPage, user_id], () => {
    refetchData()
  })

  // 数据获取
  const fetchInvoices = (ctx, callback) => {
    store
      .dispatch('commission-module/fetchInvoices', {
        pageSize: pageSize.value,
        page: currentPage.value,
        user_id: user_id.value,
        order_id: order_id.value,
      })
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalInvoices.value = total
      })
  }
  // 数据删除
  const confirmDelete = id => {
    store.dispatch('brand-module/deleteInvoices', id).then(response => {
      if (response.code == 0) {
        proxy.$bvToast.toast(response.msg, {
          title: response.msg,
          variant: 'success',
          solid: true,
        })
        refetchData()
      } else {
        proxy.$bvToast.toast(response.msg, {
          title: response.msg,
          variant: 'danger',
          solid: true,
        })
      }
    })
  }

  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    isSortDirDesc,
    refInvoiceListTable,

    statusFilter,
    isLoading,
    refetchData,
    confirmDelete,
    user_id,
    order_id,
  }
}
